export default {
  confirm: 'Confirmă',
  title: 'Oferte eligibile',
};
